import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class ConstantsService {

  public apiURL: string;
  public versionNumber: string;

  constructor() {
    this.apiURL = environment.apiURL;
    this.versionNumber = '1.4.21';
  }

}



// WEBPACK FOOTER //
// ./src/app/services/constants.service.ts